/**
 * @file Manages the postMessage analytics clientHeight methods.
 */

import React from 'react'

function ClientHeightObserver({ children }) {
  /**
   * Post cross-origin communication in domoscio object
   */
  const sendLxpLockMessage = () => {
    const clientHeight = window.document.body.clientHeight

    window.parent.postMessage({ domoscio: { lxpLock: { clientHeight: clientHeight } } }, '*')
  }

  /**
   * Observer instance (detect document height change)
   */
  const resizeObserver = new ResizeObserver(
    () => sendLxpLockMessage() // entries[0].target.clientHeight
  )

  // Init hooks
  React.useEffect(() => {
    // 1 : Post first message
    sendLxpLockMessage()

    // 2 : On windows resize -> send updated height
    window.addEventListener('resize', sendLxpLockMessage)

    // 3 : On body resize -> send updated height
    resizeObserver.observe(window.document.body)

    // 4 : Remove windows resize listener
    return () => window.removeEventListener('resize', sendLxpLockMessage)
  }, [])

  return children
}

export default ClientHeightObserver
